var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.917,
    d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333M29.333 16c0-7.364-5.97-13.333-13.333-13.333M29.333 16H2.667M16 29.333c-7.364 0-13.333-5.97-13.333-13.333M16 29.333A20.4 20.4 0 0 0 21.333 16 20.4 20.4 0 0 0 16 2.667m0 26.666A20.4 20.4 0 0 1 10.667 16 20.4 20.4 0 0 1 16 2.667M2.667 16C2.667 8.636 8.637 2.667 16 2.667"
  })));
};
export default SvgGlobe;